// Reusable sponsor / ad placement. Disabled by default — enable per placement later.
// Sponsored content is visually distinguished and always carries a disclosure label.
export function AdBlock({ placement = "generic", enabled = false, sponsor }) {
  if (!enabled) return null;
  return (
    <div data-testid={`ad-${placement}`} className="rounded-xl border border-dashed border-primary/40 bg-primary/5 p-5">
      <div className="overline text-primary mb-2">Sponsored</div>
      <div className="font-heading font-semibold text-ink">{sponsor?.label || "Presented by"} {sponsor?.name}</div>
      <p className="text-sm text-muted-foreground mt-1">{sponsor?.note}</p>
    </div>
  );
}
